import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";

const LINKS = [
  { to: "/", label: "Home", testid: "nav-home", end: true },
  { to: "/troubleshooting", label: "Troubleshooting", testid: "nav-troubleshooting" },
  { to: "/services", label: "Services", testid: "nav-services" },
  { to: "/local-services", label: "Local Services", testid: "nav-local-services" },
  { to: "/spare-parts", label: "Spare Parts", testid: "nav-spare-parts" },
  { to: "/gallery", label: "Gallery", testid: "nav-gallery" },
  { to: "/jobs", label: "Join the Team", testid: "nav-jobs" },
  { to: "/admin/login", label: "Admin", testid: "nav-admin" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const linkBase = "text-sm font-medium tracking-tight transition-colors";
  const activeCls = "text-[#16A34A]";
  const inactiveCls = "text-zinc-700 hover:text-zinc-950";

  return (
    <header className="sticky top-0 z-40 border-b border-zinc-200 bg-white/95 backdrop-blur">
      <div className="container mx-auto px-6 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" onClick={() => setOpen(false)} className="flex items-center gap-3 group">
          <img
            src="https://customer-assets.emergentagent.com/job_chatbot-finder-pro/artifacts/c7o9vj3j_708E1372-3DBC-4AE8-BA1A-7454EC4E24EC.png"
            alt="Nomad Caravan Repairs"
            className="w-9 h-9 object-contain rounded-full border border-zinc-200 bg-white p-0.5"
          />
          <div className="leading-tight">
            <div className="font-display font-black text-base tracking-tight">NOMAD CARAVAN REPAIRS</div>
            <div className="font-mono text-[10px] uppercase tracking-[0.18em] text-zinc-500">Bowen · Whitsundays</div>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {LINKS.map((l) => (
            <NavLink key={l.to} to={l.to} end={l.end} data-testid={l.testid} className={({isActive}) => `${linkBase} ${isActive?activeCls:inactiveCls}`}>{l.label}</NavLink>
          ))}
        </nav>

        <Link
          to="/request"
          data-testid="nav-request-service"
          className="hidden md:inline-flex bg-[#16A34A] text-white px-5 py-2.5 text-sm font-semibold hover:bg-[#15803D] transition-colors"
        >
          Request a Service
        </Link>

        <button
          type="button"
          onClick={() => setOpen((o) => !o)}
          data-testid="nav-mobile-toggle"
          aria-label="Toggle menu"
          className="md:hidden text-zinc-950 p-1"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <nav data-testid="nav-mobile-menu" className="md:hidden border-t border-zinc-200 bg-white">
          <div className="container mx-auto px-6 py-4 flex flex-col">
            {LINKS.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.end}
                data-testid={`${l.testid}-mobile`}
                onClick={() => setOpen(false)}
                className={({isActive}) => `py-3 border-b border-zinc-100 text-base font-medium ${isActive?activeCls:inactiveCls}`}
              >
                {l.label}
              </NavLink>
            ))}
            <Link
              to="/request"
              data-testid="nav-request-service-mobile"
              onClick={() => setOpen(false)}
              className="mt-4 inline-flex justify-center bg-[#16A34A] text-white px-5 py-3 text-base font-semibold hover:bg-[#15803D] transition-colors"
            >
              Request a Service
            </Link>
          </div>
        </nav>
      )}
    </header>
  );
}
